import { courseConstants } from "../_constants/course.constants";

const coursesInitialState = {
  courses: [],
  currentPage: 0,
  totalPage: 0,
  total: 0,
};

const courseListInitialState = {
  all: coursesInitialState,
  drafts: coursesInitialState,
  isReview: coursesInitialState,
  published: coursesInitialState,
  archived: coursesInitialState,
};

const initialState = {
  courses: { ...courseListInitialState },
  purchasedCourses: { ...courseListInitialState },
  myCourses: { ...courseListInitialState },
  viewAwardCourse: { ...courseListInitialState },
};

const Tabs = {
  ALL: "all",
  DRAFT: "draft",
  INREVIEW: "isReview",
  PUBLISHED: "published",
  ARCHIEVED: "archived",
};

// Utility function to merge courses without duplicates
const mergeCourses = (existingCourses, newCourses) => {
  const courseMap = new Map();
  existingCourses.concat(newCourses).forEach((course) => {
    courseMap.set(course?.ID, course); // Assuming 'id' is unique for each course
  });
  return Array.from(courseMap.values());
};

export function course(state = initialState, action) {
  switch (action.type) {
    case courseConstants.FETCH_START:
      return {
        ...state,
        isFetching: true,
      };
    case courseConstants.FETCH_END:
      return {
        ...state,
        isFetching: false,
      };
    case courseConstants.SET_COURSES: {
      const { courses, currentPage, totalPage, total } = action.payload;
      return {
        ...state,
        courses: {
          ...state.courses,
          [Tabs.ALL]: {
            ...state.courses[Tabs.ALL],
            courses: mergeCourses(state.courses[Tabs.ALL].courses, courses),
            currentPage,
            totalPage,
            total,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.RESET_COURSELIST: {
      const { courses, currentPage, totalPage, isFetching } = action.payload;
      return {
        ...state,
        courses: {
          ...state.courses,
          [Tabs.ALL]: {
            courses,
            currentPage,
            totalPage,
          },
        },
        isFetching,
      };
    }
    case courseConstants.MY_COURSE_LIST: {
      const { key, courses, currentPage, totalPage, total } = action.payload;
      return {
        ...state,
        myCourses: {
          ...state.myCourses,
          [key]: {
            ...state.myCourses[key],
            courses: mergeCourses(state.myCourses[key]?.courses ?? [], courses ?? []),
            currentPage,
            totalPage,
            total,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.RESET_MY_COURSELIST: {
      const { key, courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        myCourses: {
          ...state.myCourses,
          [key]: {
            courses,
            currentPage,
            totalPage,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.SEARCH_COURSES:
      return {
        ...state,
        searchResults: action.payload,
      };
    case courseConstants.SET_PURCHASED_COURSES: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        purchasedCourses: {
          ...state.purchasedCourses,
          [Tabs.ALL]: {
            ...state.purchasedCourses[Tabs.ALL],
            courses: mergeCourses(state.purchasedCourses[Tabs.ALL].courses, courses),
            currentPage,
            totalPage,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.SET_VIEW_AWARDS: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        viewAwardCourse: {
          ...state.viewAwardCourse,
          [Tabs.ALL]: {
            ...state.viewAwardCourse[Tabs.ALL],
            courses: mergeCourses(state.viewAwardCourse[Tabs.ALL].courses, courses),
            currentPage,
            totalPage,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.SET_RESET_PURCHASED_COURSES: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        purchasedCourses: {
          ...state.purchasedCourses,
          [Tabs.ALL]: {
            courses,
            currentPage,
            totalPage,
          },
        },
        isFetching: false,
      };
    }
    default:
      return state;
  }
}
